import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import EmptyStateImage from './components/Image';
import UnlockButton from './components/UnlockButton';

import { userHasFeature } from '../../helpers/Features';

const EmptyFTPAccounts = ({ link, handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Import files to your workspace via FTP' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Create unlimited FTP accounts to receive files from anyone without a workspace login.',
          })}
        </div>
        {userHasFeature('ftp') ? (
          <Button
            color="primary"
            className="mt-4"
            tag={Link}
            to={link}
            onClick={(e) => {
              e.preventDefault();
              handleNewItem();
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Create FTP account' })}
          </Button>
        ) : (
          <UnlockButton feature="ftp" />
        )}
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-ftp.png" height="high" />
    </div>
  );
};

EmptyFTPAccounts.propTypes = {
  link: PropTypes.string,
  handleNewItem: PropTypes.func,
};

EmptyFTPAccounts.defaultProps = {
  link: null,
  handleNewItem: () => { },
};

export default EmptyFTPAccounts;
